import * as React from 'react';

import AttributesTable from './AttributesTable';
import { RouteComponentProps } from 'react-router';

interface IAttributesProps extends RouteComponentProps<{
  eshop: string;
  attributeId: string;
}> {

}

export default class Attributes extends React.Component<IAttributesProps> {
  render() {
    return (
      <div>
        <AttributesTable
          domain={this.props.match.params.eshop}
          attributeId={this.props.match.params.attributeId}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Attributes/index.tsx